import styled from 'styled-components';

import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

export const DraggableScroller = styled.div`
  &.grabbing {
    cursor: grabbing;
  }
`;

export const List = styled.div`
  ${mixin.flex({ justify: 'flex-start' })};
  overflow-x: scroll;
  scrollbar-width: none;

  &.dragging {
    pointer-events: none;
    scroll-snap-type: none;
    scroll-behavior: auto;
  }
`;
